<div class="ui-screen-loader">
    <div class="ui-screen-loader-container">
        <div class="el-icon">
            <mat-icon>{{data.icon}}</mat-icon>
        </div>
        <div class="el-title">{{data.title}}</div>
        <div class="el-message">{{data.message}}</div>
        <mat-spinner class="el-spinner" [diameter]="data.loadingDiameter" *ngIf="data.loading"></mat-spinner>
    </div>
</div>